import { createFileRoute, Navigate } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const fimReviewSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
  subject: z.string().optional(),
})

/**
 * RETIRED (Mission 1, plan A9): the standalone review queue converged into the
 * Dossiers page's Review tab. This route now redirects there, mapping the old
 * `?subject=` deep link onto `?subjectId=`. The `/fim` control surface itself
 * stays internal and unchanged (its Output tab still uses ReviewDetail for
 * row-expand inspection).
 */
const RouteComponent = () => {
  const search = Route.useSearch()
  return (
    <Navigate
      to='/dossiers'
      search={{
        [SEARCH_PARAM_SITE_ID]: search[SEARCH_PARAM_SITE_ID],
        view: 'review',
        subjectId: search.subject,
      }}
      replace
    />
  )
}

export const Route = createFileRoute('/fim/review')({
  component: RouteComponent,
  validateSearch: fimReviewSearchParams,
  staticData: {
    title: 'FIM Review',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
